import VesselList from '@/components/vessel/List'
import VesselCreate from '@/components/vessel/Create'
import VesselUpdate from '@/components/vessel/Update'
import VesselShow from '@/components/vessel/Show'
import VesselShowMap from '@/components/vessel/ShowMap'
import VesselManage from '@/components/vessel/Manage'

export default [
  { name: 'VesselList', path: '/vessels/', component: VesselList },
  {
    name: 'VesselCreate',
    path: '/vessels/create/:organization_id',
    component: VesselCreate
  },
  { name: 'VesselUpdate', path: '/vessels/edit/:id', component: VesselUpdate },
  { name: 'VesselShow', path: '/vessels/show/:id', component: VesselShow },
  { name: 'VesselShowMap', path: '/vessels/map/:id', component: VesselShowMap },
  { name: 'VesselManage', path: '/vessels/manage/:id', component: VesselManage }
]
